<template>
  <section class="story-detail">
    <div class="story-detail__layout">
      <article class="story-detail__article">
        <router-link to="/success-stories" class="story-detail__back">
          ← All success stories
        </router-link>
        <h1 class="story-detail__title">{{ story.title }}</h1>
        <p v-if="story.leadHtml" class="story-detail__lead" v-html="story.lead" />
        <p v-else-if="story.lead" class="story-detail__lead">{{ story.lead }}</p>
        <StoryBlocks :blocks="story.blocks" :default-author="story.author" />
      </article>
    </div>
  </section>
</template>

<script>
import StoryBlocks from './StoryBlocks.vue';

export default {
  components: {
    StoryBlocks,
  },
  props: {
    story: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.story-detail {
  background-color: #f5f8fa;
  width: 100%;
  padding: 20px 20px 0;
  display: flex;
  justify-content: center;
}

.story-detail__layout {
  width: 100%;
  max-width: 800px;
  margin: 48px auto 0;
  padding-bottom: 80px;
}

.story-detail__back {
  display: inline-block;
  margin-bottom: 32px;
  font-weight: 600;
  font-size: 16px;
  color: #7693fc;
}

.story-detail__back:hover {
  opacity: 0.8;
}

.story-detail__title {
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
  letter-spacing: -0.02em;
  color: #17191d;
  margin-bottom: 24px;
}

.story-detail__lead {
  font-size: 18px;
  line-height: 28px;
  color: #17191d;
  margin-bottom: 32px;
}

.story-detail__lead :deep(a) {
  color: #7693fc;
  font-weight: 600;
}

.story-detail__lead :deep(a:hover) {
  opacity: 0.8;
}

.story-detail__lead :deep(strong) {
  font-weight: 600;
}

@media screen and (max-width: 768px) {
  .story-detail {
    padding: 15px 16px 0;
  }

  .story-detail__layout {
    margin-top: 60px;
    padding-bottom: 60px;
  }

  .story-detail__title {
    font-size: 36px;
    line-height: 44px;
  }
}
</style>
